type validationLabelMap = Record<string, any>;

export const validationLabels: validationLabelMap = {
    'users': {
        code: 'Person ID <span class="asap-error-message-description">(Go to Main Section)</span>',
        /* userName: 'Email <span class="asap-error-message-description">(Go to User Info Section)</span>',
        timezone: 'Timezone <span class="asap-error-message-description">(Go to User Info Section)</span>' */
    },
    'persons': {
      code: 'Person Code <span class="asap-error-message-description">(Go to Main Section)</span>',
      /* userName: 'Email <span class="asap-error-message-description">(Go to User Info Section)</span>',
      timezone: 'Timezone <span class="asap-error-message-description">(Go to User Info Section)</span>' */
  },
    'stockItems': {
        number: 'Stock Item # <span class="asap-error-message-description">(Go to Main Section)</span>',
        receiveunitofmeasure: 'Receive Unit of Measure <span class="asap-error-message-description">(Go to General Section)</span>',
        inventoryunitofmeasure: 'Inventory Unit of Measure <span class="asap-error-message-description">(Go to General Section)</span>',
        issueunitofmeasure: 'Issue Unit of Measure <span class="asap-error-message-description">(Go to General Section)</span>',
        costtype: 'Cost Type <span class="asap-error-message-description">(Go to Costing Section)</span>',
        itemtype: 'Item Type <span class="asap-error-message-description">(Go to General Section)</span>'
    },
    'categories': {
        code: 'Category Code <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'departments': {
      code: 'Department Code <span class="asap-error-message-description">(Go to Main Section)</span>',
  },
    'uom': {
        code: 'Unit Code <span class="asap-error-message-description">(Go to Main Section)</span>',
        unitName: 'Unit Name <span class="asap-error-message-description">(Go to Main Section)</span>',
        multiplier: 'Unit Multiplier <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'customers': {
        code: 'Customer ID <span class="asap-error-message-description">(Go to Main Section)</span>',
        ctid: 'Customer Type <span class="asap-error-message-description">(Go to Customer Info Section)</span>',
    },
    'addresses': {
        name: 'Address Name <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'vendors': {
        code: 'Vendor code <span class="asap-error-message-description">(Go to Main Section)</span>',
        name: 'Vendor Name <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'barcodeGenerators': {
        length: 'Length <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'transferRequests': {
        accountfromid: 'Account From <span class="asap-error-message-description">(Go to Main Section)</span>',
        accounttoid: 'Account To <span class="asap-error-message-description">(Go to Main Section)</span>',
        sitefromid: 'Site From <span class="asap-error-message-description">(Go to Main Section)</span>',
        sitetoid: 'Site To <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'pictures': {
        name: 'Image Title <span class="asap-error-message-description">(Go to Main Section)</span>',
        stream: 'Select Image <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'customForcast': {
        forecastName: 'Forcast Name',
        selectedAccount: 'Account',
        transaction: 'Receive Transaction Or Issue Transaction',
        intervalValue: 'Previous Months',
        forecastdate: 'Next Possible Date Or Provide Date',
        forecastFor: 'Forcast For',
    },
    'customReport': {
        reportName: 'Report Name',
        reportCategory: 'Report Category',
        selectedFields: 'Please select field',
    },
    'locations': {
        code: 'Location ID <span class="asap-error-message-description">(Go to Main Section)</span>',
        locationType: 'Location Type <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'locationTypes': {
        code: 'Location Type ID <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'receive': {
        date: 'Entry Date',
        site: 'Site',
        vendor: 'Vendor',
        location: 'Location',
    },
    'move': {
        date: 'Entry Date',
        site: 'Site',
        location: 'Location',
        quantity: 'Specified move quantity exceeds available quantity'
    },
    'purchaseOrder': {
        site: 'Site',
        vendor: 'Vendor',
        address: 'Address',
        poNumber: 'PO #'
    },
    'salesOrders': {},
    'issue': {
        date: 'Entry Date',
        site: 'Site',
        location: 'Location',
        quantity: 'Not enough available quantity'
    },
    'dispose': {
        date: 'Entry Date',
        site: 'Site',
        location: 'Location',
        quantity: 'Not enough available quantity'
    },
    // 'appRoles': {
    //     date: 'Entry Date',
    //     site: 'Site',
    //     location: 'Location',
    //     quantity: 'Not enough available quantity'
    // },
    'return': {
        date: 'Entry Date',
        site: 'Site',
        location: 'Location',
        quantity: 'Not enough available quantity'
    },
    'pack': {
        site: 'Site',
        salesOrder: 'Sales Order',
        packList: 'Pack List',
        notes: 'Transaction Notes'
    },
    'ship': {
        site: 'Site',
        salesOrder: 'Sales Order',
        packList: 'Pack List',
        notes: 'Transaction Notes',
        person: 'Person'
    },
    'customerTypes': {
      code: 'Customer Type Code <span class="asap-error-message-description">(Go to Main Section)</span>',
      name: 'Customer Type Name <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'disposeTo': {
      code: 'Dispose To ID <span class="asap-error-message-description">(Go to Main Section)</span>',
      description: ' Dispose To Desc <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'asset-models':{
      number:'Model # <span class="asap-error-message-description">(Go to Main Section)</span>'
    },
    'asset-models-2':{
      number:'Model # <span class="asap-error-message-description">(Go to Main Section)</span>'
    },
    'building': {
        addressid: 'Address  <span class="asap-error-message-description">(Go to Main Section)</span>',
        fileid: 'Building Image <span class="asap-error-message-description">(Go to Main Section)</span>',
        description: 'Building Description <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'floor': {
        buildingid: 'Building  <span class="asap-error-message-description">(Go to Main Section)</span>',
        fileid: 'Floor Image <span class="asap-error-message-description">(Go to Main Section)</span>',
        description: 'Floor Description <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'assets':{
      assetNumber:'Asset # <span class="asap-error-message-description">(Go to Main Section)</span>',
      locationCode:'Location <span class="asap-error-message-description">(Go to General Tab)</span>',
      modelNumber:'Model # <span class="asap-error-message-description">(Go to General Tab)</span>',
    },
    'conditions':{
      conditionId:'Condition ID <span class="asap-error-message-description">(Go to Main Section)</span>',
      description:'Description <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'asset-types':{
      modelType:'Model Type <span class="asap-error-message-description">(Go to Main Section)</span>',
      description:'Description <span class="asap-error-message-description">(Go to Main Section)</span>',
    },
    'asset-purchaseOrders': {
      site: 'Site',
      vendor: 'Vendor',
      // address: 'Address',
      poNumber: 'PO #'
    },
    'asset-reservation':{},
    'assetmove-transactions':{},
    'assetcheckout-transactions':{},
    'assetreceive-transactions':{},
    'assetcheckin-transaction':{},
    'assetdispose-transactions':{},
    'sites':{},
    'facility': {},
    'cycle-count': {
      percentage: 'Percentage <span class="asap-error-message-description">(Go to Main Section)</span>',
      transactionDate: 'Transaction Date <span class="asap-error-message-description">(Go to Main Section)</span>',
      countType: 'Count Type <span class="asap-error-message-description">(Go to Main Section)</span>'
    },
    'stockcyclecount-transactions': {
      percentage: 'Percentage <span class="asap-error-message-description">(Go to Step 1 Section)</span>',
      transactionDate: 'Transaction Date <span class="asap-error-message-description">(Go to Step 1 Section)</span>',
      countType: 'Count Type <span class="asap-error-message-description">(Go to Step 1 Section)</span>',
      cycleName: 'Session Name <span class="asap-error-message-description">(Go to Step 2 Section)</span>'
    },
    'stockcyclecountadjust-transactions': {
      transactionDate: 'Transaction Date <span class="asap-error-message-description">(Go to Step 1 Section)</span>',
      cycleCountChunk: 'Cycle Chunk <span class="asap-error-message-description">(Go to Step 1 Section)</span>'
    },
    'stockAuthorizationSettings': {
      authFlagAfterDaysStock_Warning: 'Yellow Color Code After Days',
      authFlagAfterDaysStock_Danger: 'Red Color Code After Days',
      StockAdjustSettingType: 'Stock Adjust Setting Type',
      stockAdjust_OverAmount: 'Stock Adjust Specific Dollar Amount',
      stockAdjust_TotalOverAmount: 'Stock Adjust Total Over Amount',
      stockTypeAdjust: 'Stock Adjust Item Type',
      StockDisposeSettingType: 'Stock Dispose Setting Type',
      stockDispose_OverAmount: 'Stock Dispose Specific Dollar Amount',
      stockDispose_TotalOverAmount: 'Stock Dispose Total Over Amount',
      stockTypeDispose: 'Stock Dispose Item Type'
    },
    'assetAuthorizationSettings': {
      authFlagAfterDaysAsset_Warning: 'Yellow Color Code After Days',
      authFlagAfterDaysAsset_Danger: 'Red Color Code After Days',
      AssetAdjustSettingType: 'Asset Adjust Setting Type',
      assetAdjust_OverAmount: 'Asset Adjust Specific Dollar Amount',
      assetAdjust_TotalOverAmount: 'Asset Adjust Total Over Amount',
      AssetDisposeSettingType: 'Asset Dispose Setting Type',
      assetDispose_OverAmount: 'Asset Dispose Specific Dollar Amount',
      assetDispose_TotalOverAmount: 'Asset Dispose Total Over Amount'
    }
};
